import { Entity, IEntity } from "./Entity";
import { IUser } from "./User";
import { IApp03Portfolio } from "./App03Portfolio";

export interface IApp03PortfolioUser extends IEntity {
    UserID?: number;
    App03PortfolioID?: number;
    User?: IUser;
    App03Portfolio?: IApp03Portfolio;
}

export class App03PortfolioUser extends Entity implements IApp03PortfolioUser {
    public UserID = null;
    public App03PortfolioID = null;

    constructor() {
        super();
    }
}